/** `${viewId}::${viewScope}::${fieldName}` composite key — one namespace shared by every field
 *  regardless of mode, so a field can never simultaneously be two modes (whichever mode "owns"
 *  this key wins) — the storage-layer enforcement mirrors the destination-field mutual-exclusivity
 *  rule the unification design calls for. Every "Add Field" option already carries this shape
 *  (`FlatFieldEntry.key`, `addField.ts`) since a field is always added by picking it directly (its
 *  mode defaults to Mapped/Direct and is changed afterward on the resolved row, not chosen up
 *  front) — there's no separate bare-field-name shape to reconcile against this one anymore.
 */
export const dk = (
  viewId: string,
  viewScope: "asset" | "segment",
  fieldName: string
): string => `${viewId}::${viewScope}::${fieldName}`;

export const parseDk = (
  key: string
):
  | { viewId: string; viewScope: "asset" | "segment"; fieldName: string }
  | undefined => {
  const first = key.indexOf("::");
  if (first < 0) {
    return undefined;
  }
  const second = key.indexOf("::", first + 2);
  if (second < 0) {
    return undefined;
  }
  const viewScope = key.slice(first + 2, second);
  if (viewScope !== "asset" && viewScope !== "segment") {
    return undefined;
  }
  return {
    viewId: key.slice(0, first),
    viewScope,
    fieldName: key.slice(second + 2),
  };
};
